/* Tejjari external mobile search focus */
(() => {
  if (window.tejjariMobileSearchFocusReady) return;
  window.tejjariMobileSearchFocusReady = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mobile-search-focus]');
    if (!trigger) return;
    event.preventDefault();

    const input = document.querySelector('.header__search .search__input');
    if (!input) {
      window.location.assign(trigger.href);
      return;
    }

    const search = input.closest('.header__search');
    const headerSection = input.closest('.header-section');

    // Reveal the real header search before focusing it. Keeping all of this in
    // the original tap event allows iOS and Android to open the keyboard.
    window.scrollTo(0, 0);
    headerSection?.classList.remove('header-scrolled');
    search.classList.add('tejjari-search-highlight');
    input.focus({ preventScroll: true });

    window.setTimeout(() => search.classList.remove('tejjari-search-highlight'), 1400);
  });
})();
